module.exports = __webpack_public_path__ + "static/media/image3.1c2f8a1c.png";